import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { useRouter } from "@tanstack/react-router"

export function useBlockBrowserBack(shouldBlock: boolean, message = "messages.confirmLeavePage") {
  const { t } = useTranslation()
  const router = useRouter()
  const hasBlocked = useRef(false)

  useEffect(() => {
    if (!shouldBlock) {
      return
    }

    // 브라우저 뒤로가기 방지
    const handlePopState = () => {
      if (hasBlocked.current) {
        history.back()

        return
      }

      const confirmed = confirm(t(message))

      if (!confirmed) {
        history.pushState(null, "", window.location.href) // stay on page
        hasBlocked.current = false
      } else {
        history.back()
        hasBlocked.current = true

        return
      }
    }

    if (!hasBlocked.current) {
      history.pushState(null, "", window.location.href)
    }

    window.addEventListener("popstate", handlePopState)

    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  }, [shouldBlock, message, t])

  // TanStack Router 내비게이션 방지
  useEffect(() => {
    if (!shouldBlock) {
      return
    }

    // router.history를 통한 내비게이션 감지
    const originalPush = router.history.push
    const originalReplace = router.history.replace

    router.history.push = (...args: Parameters<typeof originalPush>) => {
      const confirmed = confirm(t(message))
      if (confirmed) {
        return originalPush.apply(router.history, args)
      }

      return Promise.resolve()
    }

    router.history.replace = (...args: Parameters<typeof originalReplace>) => {
      const confirmed = confirm(t(message))
      if (confirmed) {
        return originalReplace.apply(router.history, args)
      }

      return Promise.resolve()
    }

    return () => {
      router.history.push = originalPush
      router.history.replace = originalReplace
    }
  }, [shouldBlock, message, t, router])
}
